import styled from 'styled-components'
import { mainColor } from '../../styles/global';

export const AboutWrapper = styled.div`
    padding:3% 10%;
    display:flex;
    justify-content:center;
    align-items:center;
    flex-direction: column;
    h1{ 
        font-family: 'Avenir';
        font-style: normal;
        font-weight: 600;
        font-size: 46.5434px;
        line-height: 60px;
        text-align: center;
        width:70%;
        letter-spacing: 0.01em;
        color: ${mainColor};
        @media screen and (max-width: 768px) {
            font-size: 21.0799px;
            line-height: 27px;
            width:100%;
            margin:40px 0 20px 0;
        }
    }
    p:nth-child(1) { 
        font-style: italic;
      }
    p{ 
        font-family: 'Avenir';
        font-weight: 500;
        font-size: 18px;
        line-height: 32px;
        letter-spacing: 0.01em;
        color: #8D8D8D;
        margin:10px 0;
        @media screen and (max-width: 768px) {
            font-weight: 400;
            font-size: 12px;
            line-height: 15px;
            text-align: justify;
        }
    }
   
`;

export const DestopViewImageWrap = styled.div`
        img{
            height: 100%;
            width:100%;
        }
        @media screen and (max-width: 768px) {
            display:none;
        }
`;
export const MobileViewImageWrap = styled.div`
        display:none;
        @media screen and (max-width: 768px) {
            display:block;
            img{
                height: 100%;
                width:100%;
            }
        }

`;